class TruncateText extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
  }

  connectedCallback() {
    const limit = parseInt(this.dataset.limit) || 100;
    const originalHTML = this.innerHTML.trim();

    const container = document.createElement('div');
    container.innerHTML = originalHTML;
    const totalText = container.textContent || '';

    if (totalText.length <= limit) return;

    const truncated = this._truncateNode(container.cloneNode(true), limit);
    const fullContent = container.cloneNode(true);

    const readMore = this._createToggle('Read More');
    const readLess = this._createToggle('Less');

    readMore.style.marginLeft = '0.5em';
    readLess.style.marginLeft = '0.5em';

    const truncatedWrapper = document.createElement('div');
    truncatedWrapper.appendChild(truncated);
    truncated.appendChild(readMore);

    const fullWrapper = document.createElement('div');
    fullWrapper.appendChild(fullContent);
    fullContent.appendChild(readLess);
    fullWrapper.style.display = 'none';

    this.innerHTML = '';
    this.appendChild(truncatedWrapper);
    this.appendChild(fullWrapper);

    readMore.addEventListener('click', (e) => {
      e.preventDefault();
      truncatedWrapper.style.display = 'none';
      fullWrapper.style.display = '';
      this._emitEvent('truncate-open');
    });

    readLess.addEventListener('click', (e) => {
      e.preventDefault();
      fullWrapper.style.display = 'none';
      truncatedWrapper.style.display = '';
      this._emitEvent('truncate-close');
    });
  }

  _truncateNode(node, limit) {
    let count = 0;

    const walk = (n) => {
      if (count >= limit) {
        n.remove();
        return;
      }

      if (n.nodeType === Node.TEXT_NODE) {
        const text = n.textContent;
        const remaining = limit - count;
        if (text.length > remaining) {
          n.textContent = text.slice(0, remaining) + '…';
          count = limit;
        } else {
          count += text.length;
        }
      } else if (n.nodeType === Node.ELEMENT_NODE) {
        const children = Array.from(n.childNodes);
        for (let child of children) {
          walk(child);
          if (count >= limit) {
            while (child.nextSibling) {
              child.nextSibling.remove();
            }
            break;
          }
        }
      }
    };

    walk(node);
    return node;
  }

  _createToggle(text) {
    const link = document.createElement('a');
    link.href = '#';
    link.textContent = text;
    link.className = 'truncate-toggle';
    return link;
  }

  _emitEvent(name) {
    const event = new CustomEvent(name, {
      bubbles: true,
      detail: { source: this },
    });
    this.dispatchEvent(event);
  }
}

customElements.define('truncate-text', TruncateText);
